import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnInit,
    Output,
} from '@angular/core';

import Swiper from 'swiper';
import { Autoplay, Keyboard, Pagination } from 'swiper/modules';

import { Promotion } from '@/core/domain/carousel/models/carousel-data.model';
import { GetCarouselDataUseCase } from '@/core/domain/carousel/usecases/getCarouselData.usecase';
import { SsrService } from '@/common/services/ssr/ssr.service';

@Component({
    selector: 'fe-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
    @Output() promoApplied = new EventEmitter<string>();

    promotions: Promotion[] = [];
    filteredPromotions: Promotion[] = [];

    private swiperDesktop?: Swiper;
    private swiperMobile?: Swiper;

    constructor(
        private getCarouselDataUseCase: GetCarouselDataUseCase,
        private ssr: SsrService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadPromotions();
    }

    async loadPromotions(): Promise<void> {
        this.getCarouselDataUseCase.execute().subscribe(async (carousel) => {
            if (carousel.data?.promotions) {
                this.promotions = carousel.data.promotions;
            }
            if (this.ssr.isPlatformServer()) {
                return;
            }

            await this.filterPromotions();

            this.cdr.detectChanges();

            if (this.promotions.length > 1) {
                this.initializeSwiperDesktop();
            }

            if (this.filteredPromotions.length > 1) {
                this.initializeSwiperMobile();
            }
        });
    }

    private filterPromotions(): Promise<void> {
        return new Promise((resolve) => {
            this.filteredPromotions = this.promotions;
            resolve();
        });
    }

    private initializeSwiperDesktop(): void {
        setTimeout(() => {
            const desktopSwiperContainer = document.querySelector(
                '.swiper__home.desktop',
            ) as HTMLElement;
            if (desktopSwiperContainer) {
                this.swiperDesktop = new Swiper(desktopSwiperContainer, {
                    modules: [Pagination, Autoplay, Keyboard],
                    direction: 'horizontal',
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: true,
                    },
                    keyboard: {
                        enabled: true,
                    },
                });
            }
        }, 1000);
    }

    private initializeSwiperMobile(): void {
        setTimeout(() => {
            const mobileSwiperContainer = document.querySelector(
                '.swiper__home.mobile',
            ) as HTMLElement;
            if (mobileSwiperContainer) {
                this.swiperMobile = new Swiper(mobileSwiperContainer, {
                    modules: [Pagination, Autoplay, Keyboard],
                    direction: 'horizontal',
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: true,
                    },
                    keyboard: {
                        enabled: true,
                    },
                });
            }
        }, 1000);
    }

    applyPromo(code: string) {
        this.promoApplied.emit(code);
    }
}
